/**
 * 全局工具函数
 */
import { webcall } from '@/commons/tools';
function install(Vue) {
  const tools = {
    webcall,
  };

  // 添加全局方法
  Vue.prototype.$tools = tools;
}

export default {
  install,
};
